import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { AxiosRequestConfig, AxiosError, AxiosResponse } from 'axios';
import { anonymousAxiosInstance, axiosInstance } from 'services/api';

export interface MyQueryMeta {
  status?: number;
  headers?: AxiosResponse['headers'];
}

export interface AxiosQueryArgs {
  url: string;
  method?: AxiosRequestConfig['method'];
  headers?: AxiosRequestConfig['headers'];

  data?: AxiosRequestConfig['data'];
  params?: AxiosRequestConfig['params'];
}

export type MyBaseQueryFn = BaseQueryFn<
  AxiosQueryArgs,
  unknown,
  unknown,
  MyQueryMeta
>;

const getAxiosRTKBaseQuery =
  ({ useAnonymous }: { useAnonymous: boolean }): MyBaseQueryFn =>
  async ({ url, method, data, params, headers }, { signal }) => {
    try {
      const client = useAnonymous ? anonymousAxiosInstance : axiosInstance;
      const result = await client({
        url,
        method,
        data,
        params,
        headers,
        signal,
      });
      return {
        data: result.data,
        meta: {
          status: result.status,
          headers: result.headers,
        },
      };
    } catch (axiosError) {
      const err = axiosError as AxiosError;

      if (err.code === 'ECONNABORTED' || err.code === 'ERR_CANCELED') {
        return {
          error: {
            status: 'CANCELED',
            data: 'Request aborted or timed out',
          },
        };
      }

      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
        meta: {
          status: err.response?.status,
          headers: err.response?.headers,
        },
      };
    }
  };

export default getAxiosRTKBaseQuery;
